<template class="chat-list">
    <div class="chat-user subscribe-list-item">
        <span class="user-menu__avatar">
            <img v-if="conversation.image_url" :src="conversation.image_url" alt="avatar"
                onerror="this.onerror=null;this.src='/img/icons/user.png'">
            <svg v-else width="18" height="20" viewBox="0 0 18 20">
                <use xlink:href="#svg-icn-user"></use>
            </svg>
        </span>
        <div class="d-flex flex-column ms-2">
            <strong class="mb-2">
                {{ conversation.public_name }}
            </strong>
            <span>{{ conversation.title }}</span>
        </div>
        <div class="ms-auto d-flex flex-column">
            <a :href="conversation.subscribe_url" class="btn btn--transparent-outlined">Subscribe</a>
            <a :href="conversation.ad_url" class="btn btn--primary btn--xs" style="color: #fff">See ad</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        conversation: {
            type: Object,
            required: true,
            default: null,
        },
    },
};
</script>
